import { reactive } from "vue";

// Fil d'Ariane de la barre du haut : libellé de la fiche affichée (PO, nom d'utilisateur...), après le titre de la liste.
// Vidé par la sidebar à chaque changement d'écran, renseigné par la fiche une fois chargée.
export const filAriane = reactive({ libelle: "" });
